import { render } from "./designReferenceFormPreview.vue?vue&type=template&id=7ddca238"
import script from "./designReferenceFormPreview.vue?vue&type=script&lang=js"
export * from "./designReferenceFormPreview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__